import { useState, useEffect } from 'react';
import moment from 'moment-timezone';
const TIMEZONE_MAP = {
  USA: 'America/Chicago',
  INDIA: 'Asia/Kolkata'
};
const filterValidEvents = (events, countryCode, banner) => {
  const timezone = TIMEZONE_MAP[countryCode.toUpperCase()];
  const currentTime = moment().tz(timezone);
  return events?.filter(event => {
    const eventStartTime = banner
      ? moment.tz(`${event.concert_date?.split('T')[0]} ${event.start_time}`, 'YYYY-MM-DD hh:mm A', timezone)
      : moment.tz(`${event.date?.split('T')[0]} ${event.startTime}`, 'YYYY-MM-DD hh:mm A', timezone);
    if (!eventStartTime.isValid()) return false;
    const timeDiff = eventStartTime.diff(currentTime, 'minutes');
    // Only show events that are at least 2:30 hours away
    return timeDiff >= 150;
  });
};
const handleVisibilityChange = (updateEventsCallback) => {
  if (document.visibilityState === 'visible') {
    updateEventsCallback(); // Recalculate when the user returns to the tab
  }
};

const useEventUpdater = (events, countryCode, banner, interval = 60000) => {
  const [filteredEvents, setFilteredEvents] = useState([]);
  useEffect(() => {
    const updateEvents = () => {
      const validEvents = filterValidEvents(events, countryCode, banner);
      setFilteredEvents(validEvents);
    };
    updateEvents();
    // Set interval for periodic updates
    const intervalId = setInterval(updateEvents, interval);

    const handleVisibility = () => handleVisibilityChange(updateEvents);
    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibility);
    }
  }, [events, countryCode, banner, interval]);
  return filteredEvents;
};
export default useEventUpdater;